import { Badge } from 'framework/ui/mui-builder';

const ExcludedFromBalanceBadge = (props: { isVisible?: boolean | ((data: any) => boolean) }) => (
  <Badge {...props} color="primary" sx={{ ml: 1 }}>
    Excluded from balance
  </Badge>
);

export default ExcludedFromBalanceBadge;
